import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=1cc20932&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=1cc20932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc20932",
  null
  
)

export default component.exports